import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

import { ref, watch, computed } from 'vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
import { batchSaveCustomerLabel } from '@/api/yuntuSales/customerLabelManage'

const __default__ = { name: 'CustomerLabelAddModel' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['fetch'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const dataForm = ref({ customerLabelList: [{ cosId: undefined, labelIdList: [], appId: 'cos_lbu' }] })
const customerRecord = ref<any>({})

watch(
  () => visible.value,
  (val) => {
    if (!val) {
      formRef.value?.resetFields()
      dataForm.value.customerLabelList = [{ cosId: undefined, labelIdList: [], appId: 'cos_lbu' }]
    }
  }
)

watch(
  () => customerRecord.value,
  (val) => {
    const customerLabelList = dataForm.value.customerLabelList
    const i = customerLabelList.find((item: any) => item.cosId === val.id)
    if (i) {
      i.labelIdList = val.labelIdList
      // console.log('Changed:', customerLabelList, dataForm.value.customerLabelList)
      // dataForm.value.customerLabelList = customerLabelList
      // dataForm.value = {
      //   customerLabelList: customerLabelList
      // }
    }
  },
  { immediate: true }
)

const onDelete = (index: number) => {
  dataForm.value.customerLabelList.splice(index, 1)
}

const onAdd = () => {
  dataForm.value.customerLabelList.push({ cosId: undefined, labelIdList: [], appId: 'cos_lbu' })
}

const init = () => {
  visible.value = true
}

const columns = computed(() => [
  { title: '客户名称', dataIndex: 'cosId' },
  { title: '标签', dataIndex: 'labelIdList' },
  { title: '操作', dataIndex: 'action', width: 50 }
])

const emit = __emit
const handleOk = () => {
  formRef.value?.validate().then(() => {
    loading.value = true
    const params = Object.assign({}, dataForm.value)
    batchSaveCustomerLabel(params)
      .then(() => {
        DcMessage.success('变更标签成功')
        formRef.value?.resetFields()
        visible.value = false
        emit('fetch')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  formRef.value?.resetFields()
}

__expose({ init })

return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: "变更标签",
    width: "900px",
    class: "addModel",
    "confirm-loading": loading.value,
    onOk: handleOk,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: dataForm.value,
        ref_key: "formRef",
        ref: formRef,
        class: "launchTable"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            columns: columns.value,
            dataSource: dataForm.value.customerLabelList,
            needPage: false,
            rowKey: "cosId",
            loading: loading.value,
            tableId: "customerLabelList"
          }, {
            bodyCell: _withCtx(({ column, record, index }) => [
              (column.dataIndex === 'cosId')
                ? (_openBlock(), _createBlock(_component_a_form_item, {
                    key: 0,
                    name: ['customerLabelList', index, 'cosId'],
                    rules: [{ required: true, message: '请选择客户' }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ClueAndCustomerSelect, {
                        appId: "cos_lbu",
                        value: record.cosId,
                        "onUpdate:value": ($event: any) => ((record.cosId) = $event),
                        record: customerRecord.value,
                        "onUpdate:record": _cache[0] || (_cache[0] = ($event: any) => ((customerRecord).value = $event)),
                        placeholder: "请选择客户名称",
                        allowClear: ""
                      }, null, 8, ["value", "onUpdate:value", "record"])
                    ]),
                    _: 2
                  }, 1032, ["name"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'labelIdList')
                ? (_openBlock(), _createBlock(_component_a_form_item, {
                    key: 1,
                    field: `customerLabelList[${index}].labelIdList`,
                    rules: [{ required: true, message: '请选择标签' }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerLabelCascader, {
                        type: "search",
                        appId: "cos_lbu",
                        onlyCommon: false,
                        ids: record.labelIdList,
                        "onUpdate:ids": ($event: any) => ((record.labelIdList) = $event)
                      }, null, 8, ["ids", "onUpdate:ids"])
                    ]),
                    _: 2
                  }, 1032, ["field"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 2,
                    type: "link",
                    onClick: ($event: any) => (onDelete(index))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 删除 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "dataSource", "loading"]),
          _createVNode(_component_a_button, {
            type: "primary",
            ghost: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onAdd()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("新增")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading"]))
}
}

})